// extracted by mini-css-extract-plugin
export default {"contentConstraint":"PunchupAnalytics_contentConstraint__5gKQy"};